import { render } from "./App.vue?vue&type=template&id=96b2f638"
const script = {}

import "./App.vue?vue&type=style&index=0&id=96b2f638&lang=css"

import exportComponent from "C:\\Users\\cpinkney\\Documents\\Dev\\GroupTrips3\\grouptrips-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__